/* =============================================================
   WorkInProgress.jsx — "Coming Soon" placeholder
   -------------------------------------------------------------
   Drop this as the first return in any screen that isn't ready.
   The existing screen content stays in the file — just unreachable.
   Remove the <WorkInProgress /> line to restore the real page.
   ============================================================= */

export default function WorkInProgress({ title, description, icon = 'construction' }) {
  return (
    <div className="flex-1 flex items-center justify-center min-h-[60vh]">
      <div className="text-center max-w-sm px-6">

        {/* Icon */}
        <div className="w-16 h-16 rounded-2xl bg-indigo-50 flex items-center justify-center mx-auto mb-5">
          <span className="material-symbols-outlined text-[32px] text-indigo-400">{icon}</span>
        </div>

        {/* Badge */}
        <div className="inline-flex items-center gap-1.5 bg-amber-50 text-amber-600 text-xs font-semibold px-3 py-1 rounded-full mb-4 border border-amber-200">
          <span className="material-symbols-outlined text-[13px]">schedule</span>
          Coming Soon
        </div>

        {/* Text */}
        <h2 className="text-xl font-bold text-[#0b1c30] mb-2">{title}</h2>
        <p className="text-sm text-slate-400 leading-relaxed">{description}</p>

      </div>
    </div>
  );
}
